import React from "react";
import { useOnlineStatus } from "../../hooks/useOnlineStatus";

const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = React.useState(false);
  const onlineStatus = useOnlineStatus();

  // React.useEffect(() => {
  //   const handleError = () => setHasError(true);

  //   window.addEventListener("error", handleError);

  //   return () => {
  //     window.removeEventListener("error", handleError);
  //   };
  // }, []);

  return (
    <>
      {children}

      {(hasError || !onlineStatus) && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            color: "#fff",
            textAlign: "center",
          }}
        >
          <div
            style={{
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <h1>
              {hasError
                ? "Une erreur est survenue. Veuillez actualiser la page."
                : "Pas de connexion Internet"}
            </h1>
          </div>
        </div>
      )}
    </>
  );
};

export default ErrorBoundary;
